module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flower-shop@3x_e41f25.jpg";